import { plural } from "@lingui/core/macro";
import { Button } from "@silversea-ssc/ui-components-react";
import React from "react";
import { useInstantSearch } from "react-instantsearch";

type SeeAllCruiseButtonProps = { fycPagePath?: string };

const SeeAllCruiseButton: React.FC<SeeAllCruiseButtonProps> = (props) => {
  const { results: searchResults } = useInstantSearch();
  const { fycPagePath } = props;
  if (!fycPagePath) return null;

  const nbHits = searchResults?.nbHits;
  const query = searchResults?.query;
  const fycSearchPath = `${fycPagePath}?query=${query}`;
  return (
    <Button
      renderAs="a"
      href={fycSearchPath}
      variant="secondary"
      dataContentPiece="see_all_cruises"
    >
      {plural(nbHits || 0, {
        zero: "See all Cruises",
        one: "See all # Cruise",
        other: "See all # Cruises"
      })}
    </Button>
  );
};

export default SeeAllCruiseButton;
